const protocol = [{
  desc: '获取委托代理协议',
  options: {
    url: '/ProtocolManagement/queryProtocols',
    method: 'post'
  }
}, {
  desc: '委托人协议新增修改',
  options: {
    url: '/ProtocolManagement/addOrUpdateProtocolManagement',
    method: 'post'
  }
}, {
  desc: '委托人协议删除',
  options: {
    url: '/ProtocolManagement/deleteById',
    method: 'post'
  }
}, {
  desc: '委托人协议分页列表',
  options: {
    url: '/ProtocolManagement/queryPage',
    method: 'post'
  }
}, {
  desc: '委托人协议下拉',
  options: {
    url: '/ProtocolManagement/queryProtocolNew',
    method: 'post'
  }
}, {
  desc: '委托人协议列表导出',
  options: {
    url: '/ProtocolManagement/queryProtocolManagementForExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '上传文件',
  options: {
    url: '/ProtocolManagement/uploadFile',
    method: 'post'
  }
}, {
  desc: '委托人协议批量导入数据验证',
  options: {
    url: '/ProtocolManagement/protocolManagementCheckData',
    method: 'post'
  }
}, {
  desc: '委托人协议批量导入',
  options: {
    url: '/ProtocolManagement/protocolManagementImport',
    method: 'post'
  }
}, {
  desc: '附件批量导入',
  options: {
    url: '/ProtocolManagement/uploadBatchFile',
    method: 'post'
  }
}]
export default protocol



// WEBPACK FOOTER //
// ./src/api/protocol.js